/**
 * A timeout setting for prod and test environments such that prod code that requires large debounce or delays don't need to affect the test execution time.
 * Production builds never hit the test branch (MODE is not 'test' in deployed apps).
 */
export function testAwareMs(productionMs: number, testMs = 10): number {
  return import.meta.env.MODE === 'test' ? testMs : productionMs
}
